import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useAuth } from '@/hooks/use-auth'
import { saveReturnPath } from '@/auth/session-persistence'
import { MyProjectsFilterProvider } from '@/hooks/use-my-projects-filter'
import { SocketProvider } from '@/contexts/socket-context'
import { useActivityInvalidation } from '@/hooks/use-activity-invalidation'
import { StorefrontChatAlertsMount } from '@/features/storefront-chat/alerts'
import { useEffect } from 'react'
import { Loader2 } from 'lucide-react'
import { DashboardLayout } from '@/components/layout/dashboard-layout'
import { identifyStaff } from '@/lib/analytics'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function ActivityInvalidationMount() {
  useActivityInvalidation()
  return null
}

function AnalyticsIdentityMount() {
  const { user } = useAuth()
  useEffect(() => {
    if (user) identifyStaff(user)
  }, [user])
  return null
}

export function AuthenticatedLayout() {
  const { isLoading, isAuthenticated } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      saveReturnPath(`${window.location.pathname}${window.location.search}${window.location.hash}`)
      navigate({ to: '/login' })
    }
  }, [isLoading, isAuthenticated, navigate])

  if (isLoading || !isAuthenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  return (
    <SocketProvider>
      <ActivityInvalidationMount />
      <AnalyticsIdentityMount />
      <StorefrontChatAlertsMount />
      <MyProjectsFilterProvider>
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      </MyProjectsFilterProvider>
    </SocketProvider>
  )
}
